
import React, { useEffect, useState, useRef, useContext } from "react";
import MyContext from "../../../Inventory/MyContext";
import throttle from "lodash.throttle";
import TextBoxForForm from "./TextBoxForForm";
// import { useMyContext } from "../Components/MyContext";

const TwoTextBoxSideBySide = (props) => {
    const [isEditing, setIsEditing] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [openEditIcon, setOpenEditIcon] = useState(false);
    const [getInputTxtValue, setInputTxtValue] = useState([]);
    const { setDroppedItems, setTemplateData, handleContentChange, droppedItems, stylesArray, setStylesArray, updateStyle } = useContext(MyContext);
    const displayRef = useRef(null);

    let getId1 = props.keyValueId;
    let getId2 = getId1 + "CHILD";

    let widthClass;
    switch (true) {
        case props.widthVa > 0 && props.widthVa <= 450:
            widthClass = "Two-column-mobile";
            break;
        case props.widthVa > 450 && props.widthVa <= 850:
            widthClass = "Two-column-tablet";
            break;
        default:
            widthClass = "";
            break;
    }
    const handleColumnClick = (id) => {
        props.onComponentClick(id);
    };


    const [position, setPosition] = useState({
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    })
    const updatePosition = (name, value) => {
        setPosition(prev => ({
            ...prev,
            [name]: value
        }));
    };
    useEffect(() => {
        const matchingStyle = stylesArray.find(item => item.id === getId1); //(getId1 + "innerHTML")
        if (matchingStyle) {
            const left = parseFloat(matchingStyle.style.left) || 0;
            const right = parseFloat(matchingStyle.style.right) || 0;
            const top = parseFloat(matchingStyle.style.top) || 0;
            const bottom = parseFloat(matchingStyle.style.bottom) || 0;

            setPosition({ left: left, right: right, top: top, bottom: bottom });
        }
    }, [getId1, stylesArray]);

    const [componentId, setComponentId] = useState('');
    const handleComponentId = (id) => {
        setComponentId(id);
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (componentId == getId1 + "innerHTML") {
                const moveAmount = event.ctrlKey ? 10 : 1;
                const element = document.getElementById(getId1);
                if (!element) return;

                if (event.key === "ArrowUp") {
                    event.preventDefault();
                    const newTop = position.top - moveAmount;
                    element.style.top = newTop + 'px';
                    updateStyle(getId1, 'top', newTop);
                    updatePosition('top', newTop);
                } else if (event.key === "ArrowDown") {
                    event.preventDefault();
                    const newTop = position.top + moveAmount;
                    element.style.top = newTop + 'px';
                    updateStyle(getId1, 'top', newTop);
                    updatePosition('top', newTop);
                } else if (event.key === "ArrowLeft") {
                    event.preventDefault();
                    const newLeft = position.left - moveAmount;
                    element.style.left = newLeft + 'px';
                    updateStyle(getId1, 'left', newLeft);
                    updatePosition('left', newLeft);
                } else if (event.key === "ArrowRight") {
                    event.preventDefault();
                    const newLeft = position.left + moveAmount;
                    element.style.left = newLeft + 'px';
                    updateStyle(getId1, 'left', newLeft);
                    updatePosition('left', newLeft);
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [position, componentId]);

    const clickRef = useRef();

    const handleBlur = () => {
        try {
            setTimeout(() => {
                if (clickRef.current) {
                    const id = getId1; // + 'innerHTML';
                    const updatedOuterHTML = clickRef.current.outerHTML;
                    console.log('Updated outerHTML:', updatedOuterHTML);

                    if (displayRef.current) {
                        const textData = displayRef.current.innerHTML;
                        console.log('Text Data:', textData);
                        handleContentChange(textData, id);
                    }

                    const { left, right, top, bottom } = position;

                    setStylesArray((prevStyles) =>
                        prevStyles.map((styleObj) =>
                            styleObj.id === id
                                ? {
                                    ...styleObj,
                                    style: {
                                        ...styleObj.style,
                                        left,
                                        right,
                                        top,
                                        bottom,
                                    },
                                }
                                : styleObj
                        )
                    );
                }
            }, 1000);
        } catch (error) {
            console.error(error);
        }
    };


    return (
        <div id={getId1 + "innerHTML"} style={{ position: "relative", top: position.top, bottom: position.bottom, left: position.left, right: position.right }}
            // onDragStart={props.handleDrag}
            // onDrop={props.handleDrop}
            // onDragOver={props.dragover}
            onBlur={handleBlur}
            ref={clickRef}
        >
            <div
                // onDragStart={props.handleDrag}
                // onDrop={props.handleDrop}
                // onDragOver={props.dragover}
                className={`two-column-one-web-template ${widthClass} `}
                style={{ display: 'flex', gap: "10px", width: "100%", justifyContent: "flex-start" }}
                onClick={() => handleComponentId(getId1 + "innerHTML")}
            >
                <TextBoxForForm isSingleOrTwoCol={true}
                    keyValueId={getId1}
                    handleDrag={props.handleDrag}
                    handleDrop={props.handleDrop}
                    dragover={props.dragover}
                    onClick={() => handleColumnClick(getId1)}
                    onComponentClick={props.onComponentClick}
                    handleRemoveItem={props.handleRemoveItem}
                />
                <TextBoxForForm isSingleOrTwoCol={true}
                    keyValueId={getId2}
                    handleDrag={props.handleDrag}
                    handleDrop={props.handleDrop}
                    dragover={props.dragover}
                    onClick={() => handleColumnClick(getId2)}
                    onComponentClick={props.onComponentClick}
                    handleRemoveItem={props.handleRemoveItem}
                />
            </div>
        </div>



        //     <div style={{ display: "flex", justifyContent: "flex-start" }}>
        //         <div id={props.keyValueId}
        //             className={`draggable-resizable-component-web-template fieldbox-toolpanel-web-template ${clickVtLn ? "bordered-web-template" : ""
        //                 }`}
        //             style={{
        //                 position: "static",
        //                 // minWidth: "max-content",
        //                 // minHeight: "max-content",
        //                 left: `${position.x / 14.5}%`,
        //                 // top: `${position.y / 2}%`,
        //                 // left: position.x,
        //                 top: position.y,
        //                 // width: size.width,
        //                 // height: "30px",
        //                 // cursor: isDragging ? "grabbing" : isResizing ? "nwse-resize" : "grab",
        //                 padding: "1px",
        //                 display: "flex",
        //                 alignItems: "center",
        //                 // transform: "translate(-25%, 0%)",
        //                 width: "50%",
        //                 // minHeight: "30px", 
        //                 cursor: "text",
        //                 // maxWidth: "minContent"
        //             }}
        //             ref={clickRef}
        //             onMouseDown={handleMouseDown}
        //             onMouseMove={handleMouseMove}
        //             onMouseUp={handleMouseUp}
        //             onDragStart={props.handleDrag}
        //             onDrop={props.handleDrop}
        //             onDragOver={props.dragover}
        //             onClick={toggleBar}
        //         >
        //             {isEditing ? (
        //                 <input
        //                     placeholder="Write Your Text"
        //                     className="textbox-editable"
        //                     type="text"
        //                     value={getInputTxtValue}
        //                     onChange={(e) => inputChangeValue(e.target.value)}
        //                     onBlur={handleBlur}
        //                     style={{ width: '100%' }}
        //                     onClick={handlePaste}
        //                     autoFocus
        //                 />
        //             ) : (
        //                 <div
        //                     ref={displayRef}
        //                     className="component-web-template"
        //                     onClick={handleTextClick}
        //                     style={{
        //                         width: "100%", //minHeight: "30px",
        //                         cursor: "text",
        //                         overflow: "hidden", // Ensure overflow is hidden for content
        //                         whiteSpace: "normal", // Wrap text properly
        //                         wordWrap: "break-word", // Break long words to avoid overflow
        //                         boxSizing: "border-box",
        //                         padding: "0px",
        //                         margin: "0px",
        //                     }}
        //                 >
        //                     {(getInputTxtValue && getInputTxtValue != "") ? getInputTxtValue : "Click to edit text..."}
        //                 </div>
        //             )}

        //             <button
        //                 className="component-delete-web-template"
        //                 id={props.keyValueId + "delete"}
        //                 onClick={() => props.handleRemoveItem(props.keyValueId)}
        //             >
        //                 <i className="fa-solid fa-trash"></i>
        //             </button>

        //         </div>
        //         {/* ************************************ Second *********************************** */}
        //         <div id={props.keyValueId}
        //             className={`draggable-resizable-component-web-template fieldbox-toolpanel-web-template ${clickVtLn ? "bordered-web-template" : ""
        //                 }`}
        //             style={{
        //                 position: "static",
        //                 // minWidth: "max-content",
        //                 // minHeight: "max-content",
        //                 left: `${position.x / 14.5}%`,
        //                 // top: `${position.y / 2}%`,
        //                 // left: position.x,
        //                 top: position.y,
        //                 // width: size.width,
        //                 // height: "30px",
        //                 // cursor: isDragging ? "grabbing" : isResizing ? "nwse-resize" : "grab",
        //                 padding: "1px",
        //                 display: "flex",
        //                 alignItems: "center",
        //                 // transform: "translate(-25%, 0%)",
        //                 width: "50%",
        //                 // minHeight: "30px", 
        //                 cursor: "text",
        //                 // maxWidth: "minContent"
        //             }}
        //             ref={clickRef}
        //             onMouseDown={handleMouseDown}
        //             onMouseMove={handleMouseMove}
        //             onMouseUp={handleMouseUp}
        //             onDragStart={props.handleDrag}
        //             onDrop={props.handleDrop}
        //             onDragOver={props.dragover}
        //             onClick={toggleBar}
        //         >
        //             {/* <input
        //     placeholder="Write Your Text"
        //     className="textbox-editable"
        //     type="text"
        //     // value={getInputTxtValue.find((item) => item.id === id)?.value || ""}
        //     value={getInputTxtValue}
        //     onChange={inputChangeValue}
        //     onMouseDown={(e) => e.stopPropagation()}
        //     autoFocus={clickVtLn}
        //   /> */}

        //             {isEditing ? (
        //                 <input
        //                     placeholder="Write Your Text"
        //                     className="textbox-editable"
        //                     type="text"
        //                     value={getInputTxtValue}
        //                     onChange={(e) => inputChangeValue(e.target.value)}
        //                     onBlur={handleBlur}
        //                     style={{ width: '100%' }}
        //                     onClick={handlePaste}
        //                     autoFocus
        //                 />
        //             ) : (
        //                 <div
        //                     ref={displayRef}
        //                     className="component-web-template"
        //                     onClick={handleTextClick}
        //                     style={{
        //                         width: "100%", //minHeight: "30px",
        //                         cursor: "text",
        //                         overflow: "hidden", // Ensure overflow is hidden for content
        //                         whiteSpace: "normal", // Wrap text properly
        //                         wordWrap: "break-word", // Break long words to avoid overflow
        //                         boxSizing: "border-box",
        //                         padding: "0px",
        //                         margin: "0px",
        //                     }}
        //                 >
        //                     {(getInputTxtValue && getInputTxtValue != "") ? getInputTxtValue : "Click to edit text..."}
        //                 </div>
        //             )}

        //             <button
        //                 className="component-delete-web-template"
        //                 id={props.keyValueId + "delete"}
        //                 onClick={() => props.handleRemoveItem(props.keyValueId)}
        //             >
        //                 <i className="fa-solid fa-trash"></i>
        //             </button>

        //         </div>

        //     </div>


    );
};
export default TwoTextBoxSideBySide;
